import { Dispatch, SetStateAction } from "react";
import { Box, Button } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import SearchBar from "../../components/SearchBar";
import { useNavigate } from "react-router-dom";

interface RolesListTopbarProps {
    searchTerm: string;
    setSearchTerm: Dispatch<SetStateAction<string>>;
}

const RolesListTopbar: React.FC<RolesListTopbarProps> = ({ searchTerm, setSearchTerm }) => {
    const navigate = useNavigate();

    return (
        <>
            <div className="table_header">
                <div className="left_s">
                    <Box className="search_box">
                        <SearchBar
                            value={searchTerm}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchTerm(e.target.value)}
                            onCross={() => setSearchTerm("")}
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search roles..."
                        />
                    </Box>
                </div>
                <div className="right_s">
                    <Button className="btn btn_primary" onClick={() => navigate("/manage-subadmin/roles/add")}>
                        <AddIcon /> Add Role
                    </Button>
                </div>
            </div>
        </>
    );
};

export default RolesListTopbar;
